import { Flyout } from "@amzn/stencil-react-components/flyout";
import { useContext } from "react";

import { Chatbot } from "@/components/Chatbot";
import { AppContext } from "@/stores/appStore";
import { ActionType } from "@/stores/constants";

/**
 * Flyout panel for the AI onboarding chatbot.
 * Uses Stencil Flyout for proper modal overlay, backdrop, and accessibility.
 */
export const ChatbotFlyout = (): JSX.Element => {
  const { state, dispatch } = useContext(AppContext);

  const close = () => {
    dispatch({
      type: ActionType.SET_CHATBOT_FLYOUT_VISIBLE,
      chatbotFlyoutVisible: false,
    });
  };

  return (
    <Flyout
      isOpen={state.chatbotFlyoutVisible}
      close={close}
      aria-labelledby="chatbot-flyout-title"
      dataTestId="chatbotFlyout"
    >
      <Chatbot />
    </Flyout>
  );
};
